export const STOREID = "STOREID";
export const STORE = "Store";
export const DEPOTID = "DEPOTID";
export const DEPOT = "Depot";
export const ONLINE = "online";
export const WHOLESALE = "wholesale";
export const SUPPLYCHAIN = "supplychain";
export const SUPER_USER = "super";
export const THIRD_PARTY_REPORT_TYPE = "thirdPartyOrders";
export const CUSTOMER_ORDERS_REPORT_TYPE = "customerOrders";
export const UPLOAD_FILE_PREFIX = "ThirdpartyOrderAmendments";
export const STOCK_ORDER_SERVICES = "SOMS";
export const ID_TOKEN = "id_token";
export const REFRESH_TOKEN = "refresh_token";
export const TERMINATE_TOKEN = "terminate_token";
export const TIME_REFRESH = process.env.REACT_APP_REFRESH_TIME;
export const SOMS_SECRET = process.env.REACT_APP_SOMS_SECRET;
export const All_LOCATION = {
  locationId: "All",
  locationType: "All",
  customerType: "common",
};
export const EMERGENCYORDER_DOWNLOAD_REPORT_TYPE = "emergencyOrdersLifecycle";

export const PAGE = {
  HOME: {
    key: "home",
    url: "/home",
    label: "Home",
  },
  NOT_AUTHORIZED: {
    key: "NotAuthorized",
    url: "/not-authorized",
    label: "Not Authorized",
  },
  DOWNLOAD_CUSTOMER_DEMANDS: {
    key: "downloadcustomerdemands",
    url: "/downloadcustomerdemands",
    label: "Download Third-party Customer Orders",
  },
  UPLOAD_CUSTOMER_DEMANDS: {
    key: "uploadcustomerdemands",
    url: "/uploadcustomerdemands",
    label: "Upload file to Amend/Cancel Third-party Customer Orders",
  },
  DOWNLOAD_EMERGENCY_ORDERS: {
    key: "downloademergencyorders",
    url: "/downloademergencyorders",
    label: "Download Emergency Orders Lifecycle Report",
  },
  UPLOAD_EMERGENCY_ORDERS: {
    key: "uploademergencyorders",
    url: "/uploademergencyorders",
    label: "Upload Emergency Order",
  },
  CREATE_MANUAL_ORDERS: {
    key: "createmanualorders",
    url: "/createmanualorders",
    label: "Create Manual Orders",
  },
  UPLOAD_MANUAL_ORDERS: {
    key: "uploadmanualorders",
    url: "/uploadmanualorders",
    label: "Upload Manual Orders",
  },
  VIEW_MANUAL_ORDERS: {
    key: "viewmanualorders",
    url: "/viewmanualorders",
    label: "View Manual Orders",
  },
  AMEND_MANUAL_ORDERS: {
    key: "amendmanualorders",
    url: "/amendmanualorders",
    label: "Amend Manual Orders",
  },
  APPROVE_MANUAL_ORDERS: {
    key: "approvemanualorders",
    url: "/approvemanualorders",
    label: "Approve Manual Orders",
  },
  VIEW_MANUAL_ORDERS_AUDIT_DETAILS: {
    key: "viewmanualordersauditdetails",
    url: "/viewmanualordersauditdetails",
    label: "View Manual Orders Audit Details",
  },
  SITE_CANTEEN: {
    key: "createmanualordersstores",
    url: "/createmanualordersstores",
    label: "Create Manual Orders - Stores",
  },
  GOLDEN_STORE: {
    key: "configuregoldenstores",
    url: "/configuregoldenstores",
    label: "Configure Golden Store",
  },
  MANAGE_USER: {
    key: "manageuser",
    url: "/manageuser",
    label: "Manage User",
  },
  DO_NOT_ORDER_LIST: {
    key: "donotorderlist",
    url: "/donotorderlist",
    label: "Do Not Order List",
  },
  SUPPLIER_DESTINATION_CONFIGURATION: {
    key: "supplierdestinationconfiguration",
    url: "/supplierdestinationconfiguration",
    label: "Supplier Site Id & Destination Location Configurations",
  },
  ITEM_EXCLUSION_CONFIGURATION: {
    key: "itemexclusionconfiguration",
    url: "/itemexclusionconfiguration",
    label: "D1 to D2 Item Exclusion Configurations",
  },
  VALIDATE_EMERGENCY_ORDERS: {
    key: "validateemergencyorders",
    url: "/validateemergencyorders",
    label: "Validate Emergency Order",
  },
  ERROR_FEEDBACK: {
    key: "errorfeedback",
    url: "/errorfeedback",
    label: "Validate Manual Order",
  },
  UPLOAD_MANUAL_PO_ERROR: {
    key: "uploadpoerror",
    url: "/uploadpoerror",
    label: "Upload Manual Purchase Order ",
  },
  UPLOAD_CREATE_MANUAL_ORDER_PO: {
    key: "uploadmanualorderpo",
    url: "/uploadmanualorderpo",
    label: "Create Manual Purchase Orders",
  },
  CREATE_MANUAL_ORDER_PO: {
    key: "createmanualorderpo",
    url: "/createmanualorderpo",
    label: "Create Manual Purchase Orders",
  },
  PO_SUMMARY: {
    key: "posummary",
    url: "/posummary",
    label: "Manual Purchase Orders Summary",
  },
  SPLIT_PO: {
    key: "splitpo",
    url: "/splitpo",
    label: "Split Manual Purchase Order",
  },
  PO_ENQUIRY: {
    key: "poenquiry",
    url: "/poenquiry",
    label: "Manual Purchase Order Enquiry",
  },
  PO_LIFECYCLE: {
    key: "polifecycle",
    url: "/polifecycle",
    label: "Manual Purchase Order Lifecycle",
  },
  AMEND_PO: {
    key: "amendpo",
    url: "/amendpo",
    label: "Amend Manual Purchase Order",
  },
  ORDER_PAD_MAX_CAP: {
    key: "orderpadmaxcap",
    url: "/orderpadmaxcap",
    label: "Order Pad Max Cap",
  },
  MAX_CAP_DOWNLOAD_EXTRACT: {
    key: "maxcapdownloadextract",
    url: "/maxcapdownloadextract",
    label: "Order Pad Max Cap - Download Extract",
  },
};

export const MENU_HEADERS = {
  THIRD_PARTY_ORDERS: "Third-party Customer Orders",
  EMERGENCY_ORDERS: "Emergency Orders",
  MANUAL_ORDERS: "Manual Orders",
  ADMIN: "System Administration",
  MANUAL_ORDER_PO: "Manual Purchase Orders",
};

export const ORDER_ACTIONS = {
  AMEND: "amend",
  DELETE: "delete",
  APPROVE: "approve",
  UPLOAD: "upload",
  CREATE: "create",
  BULK_AMEND: "bulk-amend",
  BULK_DELETE: "bulk-delete",
  BULK_APPROVE: "bulk-approve",
};

export const CUTOFF_ACTION = {
  amend_delete_manual_order: "amend_delete_manual_order",
  create_manual_order: "create_manual_order",
  approve_manual_orders: "approve_manual_orders",
  display_cutOff_time: "display_cutOff_time",
};

export const PRODUCT_TYPE = {
  Ambient: "ambient",
  Frozen: "frozen",
  Fresh_Night_Pick_Item: "fresh night pick",
  Fresh_Day_Pick_Item: "fresh day pick",
};

export const PO_STATUS = {
  PENDING: "pending",
  CANCELLED: "cancelled",
  SOMS_CANCELLED: "somsCancelled",
  CONFIRMED: "confirmed",
  AMENDED: "amended",
  SOMS_AMENDED: "somsAmended",
  RAISED: "raised",
  REQUEST_RAISED: "requestRaised",
  REJECTED: "rejected",
  DRAFT: "draft",
  DRAFT_CANCELLED: "draftCancelled",
  PENDING_CANCELLED: "pendingCancelled",
  CLOSED: "closed"
};

export const PO_ITEM_STATUS = {
  CREATE: 'create',
  REMOVE: 'remove',
  INACTIVE: 'inactive',
  DRAFT: 'draft',
  SOMS_AMENDED: 'somsAmended'
}

export const PO_ELEMENTS = {
  UPLOAD_PO: {
    UPLOAD_TAB: "uploadTab",
    SUBMIT_BUTTON: "submitButton",
    CONFIRM_WITHOUT_REVIEW: "confirmWithoutReviewButton",
    REVIEW_BUTTON: "reviewButton",
  },
  CREATE_PO: {
    CREATE_TAB: "createTab",
    CONFIRM_BUTTON: "confirmButton",
    SAVE_BUTTON: "saveButton",
    BACK_BUTTON: "backButton",
  },
  AMEND_PO: {
    CONFIRM_BUTTON: "confirmButton",
    SAVE_BUTTON: "saveButton",
    BACK_BUTTON: "backButton",
    ADD_ITEM_BUTTON: "addItemButton",
    REMOVE_ITEM_BUTTON: "removeItemButton",
    DOWNLOAD_AS_PDF_BUTTON: "downloadAsPdfButton",
  },
  PO_SUMMARY: {
    AMEND_BUTTON: "amendButton",
    CONFIRM_BUTTON: "confirmButton",
    CANCEL_BUTTON: "cancelButton",
    LIFECYCLE_BUTTON: "lifecycleButton",
    SPLIT_BUTTON: "splitButton",
  },
  UPLOAD_EMERGENCY_ORDERS_TAB:{
    UPLOAD_TAB : "uploadTab",
    BBALLOC_TAB : "bballocUploadTab",
  }
};

export const PO_REASON = {
  ORDER_TYPE: "Manual Purchase Orders",
  ORDER_SUB_TYPE: {
    CANCEL: "Cancellation",
    AMEND: "Amendment",
    CREATE: "Create",
  },
};

export const PRODUCT_DETAILS_TYPE = {
  STORE_CATALOGUE: "storeCatalogue",
  MANUAL_PURCHASE_ORDER: "manualPurchaseOrder",
};

export const USER_ROLE = {
  CENTRAL_IMPORTS: "Central Imports",
};

export const FEATURE = {
  DNO:"PurchaseOrdering",
  D1D2:"d1d2",
  DNO_FEATURE_SETTING: "purchaseOrderingRestrictedItems",
  D1D2_FEATURE_SETTING: "d1d2RestrictedItems",
}

